module.exports = __webpack_public_path__ + "img/MEMEX-logo.1fa44947.svg";